var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#C4342B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.512 13.2829C14.6088 13.1767 14.7324 13.0984 14.8699 13.0564C15.0074 13.0144 15.1537 13.0102 15.2933 13.0442L32.097 17.1552C32.1987 17.1789 32.2914 17.2221 32.3753 17.2847L35.7942 19.7769C35.9602 19.8995 36.0724 20.0813 36.1074 20.2845C36.1424 20.4877 36.0976 20.6966 35.9822 20.8675L24.2199 38.0656C24.1374 38.1879 24.0225 38.2848 23.888 38.3455C23.7535 38.4062 23.6048 38.4282 23.4584 38.409C23.3121 38.3899 23.174 38.3304 23.0596 38.2373C22.9453 38.1441 22.8591 38.0209 22.8109 37.8815L14.3532 14.084C14.3054 13.9487 14.295 13.8031 14.3229 13.6624C14.3509 13.5216 14.4162 13.3897 14.512 13.2829ZM17.2855 17.5793L23.1578 34.1007L24.1233 25.5397L17.2855 17.5793ZM25.6962 25.8152L24.7154 34.5247L33.0207 22.3796L25.6962 25.8152ZM33.7703 20.2708L28.4151 22.7796L32.003 18.9834L33.7703 20.2708ZM30.3882 18.3766L17.3236 15.1797L24.9835 24.0923L30.3882 18.3766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/Tron.d9ec4accac938cccb51fa93323813427.svg";
export { ForwardRef as ReactComponent };